module.exports = __webpack_public_path__ + "static/category-page-1-a0d59ff92bcb074c5fef59e0b7177ae2.png";